@if (accountNumber && variableSymbol) {
  <div>
    @if (!qrImageData) {
      <div >{{  getQrString() }}</div>
    }
    @if (qrImageData) {
      <img src="{{ qrImageData }}" alt="">
    }
  </div>
}